import { render, staticRenderFns } from "./FactorMain.vue?vue&type=template&id=1be7c59c&scoped=true"
import script from "./FactorMain.vue?vue&type=script&lang=js"
export * from "./FactorMain.vue?vue&type=script&lang=js"
import style0 from "./FactorMain.vue?vue&type=style&index=0&id=1be7c59c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be7c59c",
  null
  
)

export default component.exports